import { Metrics } from './Metrics';

export type RequestName =
  | 'fetchconditionalpropertyrules'
  | 'fetchdecryptedhighlysensitivepropertyvalue'
  | 'fetchvalidationforrecordv2'
  | 'savepropertyvalues'
  | 'validatepropertyvalues';

export type RequestErrorClass =
  | '4xx'
  | '5xx'
  | 'aborted'
  | 'network'
  | 'timeout'
  | 'unknown';

export const getRequestErrorClass = (error: unknown): RequestErrorClass => {
  if (!error || typeof error !== 'object') {
    return 'unknown';
  }

  const { errorCode, status } = error as {
    errorCode?: unknown;
    status?: unknown;
  };

  if (errorCode === 'ABORT') {
    return 'aborted';
  }
  if (errorCode === 'TIMEOUT') {
    return 'timeout';
  }
  if (typeof status !== 'number') {
    return 'unknown';
  }
  if (status === 0) {
    return 'network';
  }
  if (status >= 400 && status < 500) {
    return '4xx';
  }
  if (status >= 500) {
    return '5xx';
  }
  return 'unknown';
};

export const trackRequest = (name: RequestName) => {
  const startTime = performance.now();
  const updateLatency = (status: 'success' | 'failure') => {
    Metrics.timer(`${name}-latency`, { status }).update(
      performance.now() - startTime
    );
  };

  return {
    success: () => {
      updateLatency('success');
      Metrics.counter(`${name}-success`).increment();
      Metrics.counter(name, { status: 'success' }).increment();
    },
    failure: (error: unknown) => {
      updateLatency('failure');
      Metrics.counter(`${name}-failure`).increment();
      Metrics.counter(name, {
        status: 'failure',
        errorClass: getRequestErrorClass(error),
      }).increment();
    },
  };
};
